<template>
  <b-button 
    variant="primary" 
    disabled
    class="w-100" 
    @click="$emit('click')" 
    v-b-tooltip.hover 
    title="Antecipação automática da conta">
    Antecipação Automática
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue';

export default {
  name: 'AutomaticAntecipationButton',
  components: { BButton },
};
</script>
